import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class EmailService {

    public url = url;

    constructor(private http:HttpClient){

    }

    sendMessage( value, title) {

        let headers = new HttpHeaders();
        headers.append('Content-Type' , 'application/json');
        let mydata = {
            content : value,
            title : title
        };
        let body = JSON.stringify( { data: mydata, title: title} );

        return this.http.post(this.url+'email/old/PHPMailer/sendMessage.php',body,{ headers }).pipe(map( resp => {
            return resp
        }));

    }
    sendMessageSeveral( value, title){

        let headers = new HttpHeaders();
        headers.append('Content-Type' , 'application/json');
        let mydata = {
            content : value,
            title : title
        };
        let body = JSON.stringify( { data: mydata, title: title} );

        return this.http.post(this.url+'email/old/PHPMailer/sendMessageSeveral.php',body,{ headers }).pipe(map( resp => {
            return resp
        }));

    }

    sendMessageCogidaDiaria( value, title) {

        let headers = new HttpHeaders();
        headers.append('Content-Type' , 'application/json');
        let mydata = {
            content : value,
            title : title
        };
        let body = JSON.stringify( { data: mydata, title: title} );

        return this.http.post(this.url+'email/old/PHPMailer/sendMessageCogida.php',body,{ headers }).pipe(map( resp => {
            return resp
        }));

    }

}